import { Injectable } from '@angular/core';

@Injectable()
export class Const {
  public static readonly CurrentUser = 'CurrentUser';
  public static readonly RememberMe = 'RememberMe';

}
